import React, { useEffect, useState } from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import { getCreatorQualitySignalVariant } from '../../../../experimentation';
import { OrganiserListingPageVariantA } from '../OrganiserListingPageVariantA/OrganiserListingPageVariantA';
import { OrganiserListingPageVariantB } from '../OrganiserListingPageVariantB/OrganiserListingPageVariantB';
import { SimplifiedOrganizerInfo } from '../SimplifiedOrganizerInfo';

export interface OrganiserListingPageProps {
    organizerName: string;
    organizerId: string;
    trustSignal?: React.ReactNode;
    organizerAvatar?: string;
    pageArea?: string;
    signalType?: string;
}

const OrganiserListingPage = ({
    organizerName,
    organizerAvatar,
    organizerId,
    pageArea,
    trustSignal,
    signalType,
}: OrganiserListingPageProps) => {
    const [showVariantType, setVariantType] = useState('control');

    useEffect(() => {
        if (signalType && signalType.length > 0) {
            const variant = getCreatorQualitySignalVariant();
            setVariantType(variant);
        }
    }, [signalType]);

    return (
        <div data-testid="creator-signal-main-section">
            {showVariantType === 'control' && (
                <SimplifiedOrganizerInfo
                    organizerName={organizerName}
                    organizerAvatar={organizerAvatar}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                />
            )}

            {showVariantType === 'variant-a' && (
                <OrganiserListingPageVariantA
                    organizerName={organizerName}
                    organizerAvatar={organizerAvatar}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                    trustSignal={trustSignal}
                    signalType={signalType}
                />
            )}
            {showVariantType === 'variant-b' && (
                <OrganiserListingPageVariantB
                    organizerName={organizerName}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                    trustSignal={trustSignal}
                    signalType={signalType}
                    organizerAvatar={organizerAvatar}
                />
            )}
        </div>
    );
};

export default OrganiserListingPage;
